import CollectPaymentDialog from './CollectPaymentDialog'

export default CollectPaymentDialog
